import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { QuestionnairesGroupComponent } from '../questionnaires-group/questionnaires-group.component';
import { QuestionnairesComponent } from '../questionnaires/questionnaires.component';


const routes: Routes = [
  {
    path: 'list',
    component: QuestionnairesComponent
  },
  {
    path: 'group',
    component: QuestionnairesGroupComponent
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class QuestionnairePanelRoutingModule { }
